module.exports = __webpack_public_path__ + "img/ke.87900162.svg";